import { render, staticRenderFns } from "./GenericConfirmationModal.vue?vue&type=template&id=af23451a&scoped=true&"
import script from "./GenericConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./GenericConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./GenericConfirmationModal.vue?vue&type=style&index=0&id=af23451a&lang=scss&scoped=true&"
import style1 from "./GenericConfirmationModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af23451a",
  null
  
)

export default component.exports